/* Upsalg i kurv-skuffen: læg varen i kurven og tegn skuffen om, uden at lukke den. */
(function () {
  if (window.__lkUpsell) return;
  window.__lkUpsell = true;

  function skuffe() {
    return document.querySelector('cart-drawer');
  }

  function sektioner() {
    var d = skuffe();
    if (d && typeof d.getSectionsToRender === 'function') {
      return d.getSectionsToRender().map(function (s) { return s.id; });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function tegnOm() {
    var d = skuffe();
    var liste = sektioner().join(',');
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(liste), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (d && typeof d.renderContents === 'function') {
          d.renderContents({ sections: sections });
        } else {
          window.location.reload();
        }
      });
  }

  document.addEventListener('click', function (event) {
    var knap = event.target.closest && event.target.closest('[data-lk-add]');
    if (!knap || knap.disabled) return;
    event.preventDefault();

    var id = knap.getAttribute('data-lk-add');
    var etiket = knap.querySelector('[data-lk-label]');
    var tekst = etiket ? etiket.textContent : '';
    knap.disabled = true;
    if (etiket) etiket.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('kurven svarede ' + r.status);
        return r.json();
      })
      .then(function () {
        // Skuffen tegnes om fra serveren, så både linjer, total og fragtmåler passer.
        return tegnOm();
      })
      .catch(function () {
        knap.disabled = false;
        if (etiket) etiket.textContent = tekst;
      });
  });
})();
